import jwtDefaultConfig from './jwtDefaultConfig'

export default class JwtService {
  // jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig };

  constructor(jwtOverrideConfig) {
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig };
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value);
  }

  getToken() {
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName);
  }

  setLoginInfo(loginInfo) {
    const { permissions } = loginInfo;
    delete loginInfo.permissions;

    localStorage.setItem(this.jwtConfig.storageUserDataName, JSON.stringify(loginInfo));
    localStorage.setItem(this.jwtConfig.storagePermissions, JSON.stringify(permissions));
  }

  getUserData() {
    return JSON.parse(localStorage.getItem(this.jwtConfig.storageUserDataName));
  }

  getPermissions() {
    return JSON.parse(localStorage.getItem(this.jwtConfig.storagePermissions));
  }

  logout() {
    localStorage.removeItem(this.jwtConfig.storageTokenKeyName);
    localStorage.removeItem(this.jwtConfig.storageUserDataName);
    localStorage.removeItem(this.jwtConfig.storagePermissions);

    sessionStorage.removeItem(this.jwtConfig.agentMessageKey);
    sessionStorage.removeItem(this.jwtConfig.agentStatusKey);
  }
}
